import { render, staticRenderFns } from "./BulkWizardStudentList.vue?vue&type=template&id=e9c7dc84&scoped=true&"
import script from "./BulkWizardStudentList.vue?vue&type=script&lang=js&"
export * from "./BulkWizardStudentList.vue?vue&type=script&lang=js&"
import style0 from "./BulkWizardStudentList.vue?vue&type=style&index=0&id=e9c7dc84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c7dc84",
  null
  
)

export default component.exports